var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.eleName,{tag:"component",attrs:{"element-data":_vm.elementData,"trade-data":_vm.tradeData,"fund-code":_vm.fundCode,"merge-data":_vm.mergeData,"product-seats-info":_vm.productSeatsInfo,"index-info":_vm.indexInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }